var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import DotsVerticalSvg from './dots-vertical.icon.svg';
export const DotsVerticalIcon = (iconInstanceProps) => {
    return _jsx(Icon, { ...iconInstanceProps, SvgComponent: DotsVerticalSvg });
};
_react_refresh_temp_1 = DotsVerticalIcon;
$RefreshReg$(_react_refresh_temp_1, "DotsVerticalIcon");
